import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-arre-black border-t border-arre-border mt-20" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.png" alt="Arre Sonora" className="h-14 w-14 object-contain" />
              <div className="leading-none">
                <div className="font-display text-2xl tracking-wider text-white">¡ARRE!</div>
                <div className="font-display text-2xl tracking-wider text-arre-red -mt-1">SONORA</div>
              </div>
            </div>
            <p className="text-white/50 text-sm max-w-xs">
              Boutique de carnes premium. 100% carne sonorense, la mejor calidad de México. Del rancho a tu parrilla.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="text-white/50 hover:text-arre-red transition" aria-label="Instagram">
                <Instagram className="w-5 h-5" strokeWidth={1.5} />
              </a>
              <a href="#" className="text-white/50 hover:text-arre-red transition" aria-label="Facebook">
                <Facebook className="w-5 h-5" strokeWidth={1.5} />
              </a>
              <a href="mailto:hola@arresonora.com" className="text-white/50 hover:text-arre-red transition" aria-label="Email">
                <Mail className="w-5 h-5" strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-xl tracking-wider uppercase text-white mb-4">Explora</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/paquetes" className="text-white/60 hover:text-white">Paquetes</Link></li>
              <li><Link to="/arma-tu-paquete" className="text-white/60 hover:text-white">Arma tu combo</Link></li>
              <li><Link to="/catalogo/cortes" className="text-white/60 hover:text-white">Cortes Premium</Link></li>
              <li><Link to="/regalo" className="text-white/60 hover:text-white">Tarjetas de regalo</Link></li>
              <li><Link to="/empresas" className="text-white/60 hover:text-white">Programa corporativo</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-xl tracking-wider uppercase text-white mb-4">Tu cuenta</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/favoritos" className="text-white/60 hover:text-white">Mis favoritos</Link></li>
              <li><Link to="/cuenta" className="text-white/60 hover:text-white">Mi cuenta</Link></li>
              <li><Link to="/rastreo" className="text-white/60 hover:text-white">Rastrear pedido</Link></li>
              <li><a href="#" className="text-white/60 hover:text-white">Políticas de envío</a></li>
              <li><a href="https://wa.me/526621234567" target="_blank" rel="noreferrer" className="text-white/60 hover:text-white">WhatsApp soporte</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-xl tracking-wider uppercase text-white mb-4">Contacto</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-arre-red" />
                <span>Hermosillo, Sonora, México</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-arre-red" />
                <span>+52 662 123 4567</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-arre-red" />
                <span>hola@arresonora.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-arre-border flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Arre Sonora — Boutique de Carnes. Todos los derechos reservados.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Términos</a>
            <a href="#" className="hover:text-white">Privacidad</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
